module.exports = __webpack_public_path__ + "img/07_logo_1_kecc_white.abf7c1bc.svg";